import { appLogout, startListening } from '@betty/toolkit/state';
import { UpdateLimitsErrorPayload } from '../state/limits.types';
import { clearLimitsData, updateLimits } from '../state/limits.slice';
import { BottomSheet } from '@betty/navigation';

startListening({
  actionCreator: updateLimits.fulfilled,
  effect: (_) => {
    BottomSheet.open({
      namespace: 'common',
      type: 'Info',
      titleNS: 'responsibleGaming',
      titleKey: 'limitsSavedTitle',
      data: {
        textNS: 'responsibleGaming',
        textKey: 'limitsSavedDescription',
      },
    });
  },
});

startListening({
  actionCreator: updateLimits.rejected,
  effect: (action) => {
    const payload = action.payload as UpdateLimitsErrorPayload;

    const errorCode = payload?.data.errorCode;

    BottomSheet.open({
      namespace: 'common',
      type: 'Info',
      titleNS: 'common',
      titleKey: 'errorTitle',
      data: {
        textNS: 'responsibleGaming',
        textKey: `${errorCode}-description`,
      },
    });
  },
});

startListening({
  actionCreator: appLogout,
  effect: (_, { dispatch }) => {
    dispatch(clearLimitsData());
  },
});
